export default {
  category: 'Category',
  categories: 'Categories',
  verbose_category: 'a category',
  related_categories: 'Related categories',
};
